// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const CLOUDFLARE_WORKERS_AI_MODELS = {
	"@cf/google/gemma-4-26b-a4b-it": {
		id: "@cf/google/gemma-4-26b-a4b-it",
		name: "Gemma 4 26B A4B IT",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"@cf/ibm-granite/granite-4.0-h-micro": {
		id: "@cf/ibm-granite/granite-4.0-h-micro",
		name: "Granite 4.0 H Micro",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.017,
			output: 0.112,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131000,
		maxTokens: 131000,
	} satisfies Model<"openai-completions">,
	"@cf/meta/llama-3.3-70b-instruct-fp8-fast": {
		id: "@cf/meta/llama-3.3-70b-instruct-fp8-fast",
		name: "Llama 3.3 70B Instruct fp8 Fast",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.293,
			output: 2.253,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 24000,
		maxTokens: 24000,
	} satisfies Model<"openai-completions">,
	"@cf/meta/llama-4-scout-17b-16e-instruct": {
		id: "@cf/meta/llama-4-scout-17b-16e-instruct",
		name: "Llama 4 Scout 17B 16E Instruct",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.27,
			output: 0.85,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131000,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"@cf/mistralai/mistral-small-3.1-24b-instruct": {
		id: "@cf/mistralai/mistral-small-3.1-24b-instruct",
		name: "Mistral Small 3.1 24B Instruct",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.351,
			output: 0.555,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 128000,
	} satisfies Model<"openai-completions">,
	"@cf/moonshotai/kimi-k2.6": {
		id: "@cf/moonshotai/kimi-k2.6",
		name: "Kimi K2.6",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.16,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 256000,
	} satisfies Model<"openai-completions">,
	"@cf/moonshotai/kimi-k2.7-code": {
		id: "@cf/moonshotai/kimi-k2.7-code",
		name: "Kimi K2.7 Code",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.19,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"@cf/nvidia/nemotron-3-120b-a12b": {
		id: "@cf/nvidia/nemotron-3-120b-a12b",
		name: "Nemotron 3 Super 120B",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.5,
			output: 1.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"openai-completions">,
	"@cf/openai/gpt-oss-120b": {
		id: "@cf/openai/gpt-oss-120b",
		name: "GPT OSS 120B",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.35,
			output: 0.75,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"@cf/openai/gpt-oss-20b": {
		id: "@cf/openai/gpt-oss-20b",
		name: "GPT OSS 20B",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.2,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"@cf/qwen/qwen3-30b-a3b-fp8": {
		id: "@cf/qwen/qwen3-30b-a3b-fp8",
		name: "Qwen3 30B A3b fp8",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.0509,
			output: 0.335,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 32768,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"@cf/zai-org/glm-4.7-flash": {
		id: "@cf/zai-org/glm-4.7-flash",
		name: "GLM-4.7-Flash",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.0605,
			output: 0.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"@cf/zai-org/glm-5.2": {
		id: "@cf/zai-org/glm-5.2",
		name: "Glm 5.2",
		api: "openai-completions",
		provider: "cloudflare-workers-ai",
		baseUrl: "https://api.cloudflare.com/client/v4/accounts/{CLOUDFLARE_ACCOUNT_ID}/ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsLongCacheRetention":false,"sendSessionAffinityHeaders":true},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.4,
			output: 4.4,
			cacheRead: 0.26,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
} as const;
